(() => {
  document.querySelectorAll('[data-catalog]').forEach((root) => {
    const panel = root.querySelector('[data-catalog-panel]');
    const openButton = root.querySelector('[data-catalog-open]');
    const closeButtons = root.querySelectorAll('[data-catalog-close]');
    const sort = root.querySelector('[data-catalog-sort]');
    const form = root.querySelector('.catalog-filters');
    const mobile = window.matchMedia('(max-width: 900px)');

    const setOpen = (open) => {
      if (!panel) return;
      const shouldOpen = mobile.matches && open;
      root.classList.toggle('filters-open', shouldOpen);
      panel.classList.toggle('is-open', shouldOpen);
      panel.setAttribute('aria-hidden', String(mobile.matches && !shouldOpen));
      panel.inert = mobile.matches && !shouldOpen;
      openButton?.setAttribute('aria-expanded', String(shouldOpen));
      document.body.classList.toggle('catalog-locked', shouldOpen);
    };

    openButton?.addEventListener('click', () => setOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    sort?.addEventListener('change', () => form?.requestSubmit());

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('filters-open')) setOpen(false);
    });

    const syncViewport = () => {
      if (mobile.matches) setOpen(false);
      else {
        panel?.classList.remove('is-open');
        panel?.setAttribute('aria-hidden', 'false');
        if (panel) panel.inert = false;
        document.body.classList.remove('catalog-locked');
      }
    };

    mobile.addEventListener?.('change', syncViewport);
    syncViewport();
  });
})();
